import { sgiLogger } from "rt-sd-common/sgiCommon/sgiLogger";
import { getConstByKey, getFunctionByKey, testReactVsn, setFunction } from "./sgiBaseComp/SgiCommon";

/**
 * 容器组件的公共方法
 * wangz
 * 2018.3.9
 */

/**
* 属性转换
* @param {描述信息} moduleDesc
* @param {属性} formProps
*/
var addCtnCommonAttribute = function (currentModule, moduleDesc, ctnProps, ctnBodyProps) {
    var cId = moduleDesc.cId; //cid 唯一标示
    if (cId) ctnProps.id = getConstByKey(currentModule, cId);

    var ctlW = moduleDesc.ctlW; //form宽度
    ctnProps.style.width = ctlW;
    if (ctlW == 0 || ctlW == '0px') {
        ctnProps.style.width = undefined;
    }

    var ctlH = moduleDesc.ctlH; //form高度
    ctnProps.style.height = ctlH;
    if (ctlH == 0 || ctlH == '0px') {
        ctnProps.style.height = undefined;
    }

    var isBrdr = moduleDesc.isBrdr; //form是否有边框??没实现
    if (isBrdr) {
        ctnProps.style.border = "1px solid rgb(217, 217, 217)";/*边线宽度 类型 颜色*/;
    } else {
        ctnProps.style.border = undefined;
    }

    var mgn = moduleDesc.mgn; //form外边距
    if (mgn) ctnProps.style.margin = mgn;
    var pad = moduleDesc.pad; //form内边距
    if (pad) ctnProps.style.padding = pad;

    var isHdn = moduleDesc.isHdn; //form是否隐藏
    if (isHdn) {
        ctnProps.style.display = "none";
    } else {
        ctnProps.style.display = undefined;
    }

    var isScl = moduleDesc.isScl; //form是否可以滚动
    if (isScl) {
        if (!ctnBodyProps) ctnProps.style.overflow = "auto";
        if (ctnBodyProps) ctnBodyProps.style.overflow = "auto";
    } else {
        if (!ctnBodyProps) ctnProps.style.overflow = undefined;
        if (ctnBodyProps) ctnBodyProps.style.overflow = undefined;
    }

    //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
    // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
    //     var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
    //     if (te) ctnProps.te = te;
    // }
    var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
    ctnProps.te = te;

    // 初始加载中
    currentModule.state.loading = !!moduleDesc.loading;

    // 自定义样式
    const getCstmStyle = getFunctionByKey(currentModule, "cstmStyle");
    if (getCstmStyle) {
        // currentModule.state.cstmStyle = getCstmStyle;
    } else {
        let cstmStyle = moduleDesc.cstmStyle;
        let $cstmStyle;
        if (cstmStyle) {
            try {
                $cstmStyle = new Function("module", "objFct", cstmStyle);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            // 不再在state中存放方法
            // currentModule.state.cstmStyle = $cstmStyle;
            setFunction(currentModule, "cstmStyle", $cstmStyle);
        }
    }
}

var sgiCtnBaseFun = {
    /**
     * 设置是否隐藏
     */
    setHidden: function (value) {
        let props = this.state.formProps || this.state.panelProps || this.state.tabsProps
            || this.state.collapseProps || this.state.CardProps;
        if (value) {
            props.style.display = "none"
        } else {
            props.style.display = undefined;
        }
        if (testReactVsn(this, 16)) {
            // react16需要更新引用
            props.style = { ...props.style };
        }
        this.setState({ loading: false });
    },
    add: function (module) {
        if (!module) {
            return;
        }
        let sonItems = this.state.formItems || this.state.panelItems;
        if (!sonItems) {
            return;
        }
        sonItems.push(module);
        if (testReactVsn(this, 16)) {
            // react16需要更新引用
            sonItems = [...sonItems];
        }
        this.setState({ loading: false })
    },
    removeAll: function () {
        this.props.moduleDesc.cldSet = [];
        this.refresh();
    },
    /**
     * id 可能为guid 可能为cid
     */
    remove: function (id) {
        if (!id) {
            return;
        }
        let sonItems = this.props.moduleDesc.cldSet;
        if (!sonItems) {
            return;
        }
        let tmpItem;
        let tmpId;
        for (var i = 0; i < sonItems.length; i++) {
            tmpItem = sonItems[i];
            if (!tmpItem) {
                continue;
            }
            tmpId = tmpItem.guid || getConstByKey(this, tmpItem.cId);
            if (id == tmpId) {
                sonItems.splice(i, 1);
                break;
            }
        }
        this.refresh();
    },
    setLoading: function (loading) {
        this.setState({ loading });
    },
    // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
    renderBeforeReturn: function (wrapProps) {
        const { parentModule, moduleDesc, objFct, type } = this.props;

        // 自定义样式处理
        // const getCstmStyle = this.state.cstmStyle;
        const getCstmStyle = getFunctionByKey(this, "cstmStyle");;
        let cstmStyle = {};
        if (getCstmStyle) {
            try {
                cstmStyle = getCstmStyle(this, objFct) || {};
            } catch (error) {
                tool.sgiLogger.log(error);
            }
        }
        Object.assign(wrapProps.style, cstmStyle);

    },
}

export { addCtnCommonAttribute, sgiCtnBaseFun };
export default { addCtnCommonAttribute, sgiCtnBaseFun };



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCtnComm.js